import { configureStore } from '@reduxjs/toolkit';
import finReducer from "./finslice"
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, finReducer);

const store = configureStore({
  reducer: {
    fin: persistedReducer,
  },
});


export const persistor = persistStore(store);
export default store;